// Sentry.init({
//   dsn:
//     "https://6133f592bca04659af0a1ecd74c95705@o338722.ingest.sentry.io/5303430",
// });
import api, { waitForAuth } from "@/api";

import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import "./registerServiceWorker";
import PortalVue from "portal-vue";
import Clipboard from "v-clipboard";
import asyncComputed from "vue-async-computed";
import Keypress from "vue-keypress";
import Antd from 'ant-design-vue';
import "ant-design-vue/dist/antd.css";

Vue.component("Keypress", Keypress);
Vue.use(Clipboard);
Vue.use(asyncComputed);

Vue.config.productionTip = false;
Vue.use(PortalVue);

Vue.use(Antd);

// plugins
import vuetify from "./plugins/vuetify";
import vProgress from "./plugins/progressbar";
import i18n from "@/plugins/i18n";

// get app state
import state from "@/state";
// do something with state: set in vuex

// set api prototype
Vue.prototype.$api = api;

// set other core dependencies.
import "leaflet/dist/leaflet.css";
import "leaflet-timedimension/dist/leaflet.timedimension.control.min.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css"; // Re-uses images from ~leaflet package
import L from "leaflet";
import "leaflet-timedimension";
import "leaflet-draw";
import "leaflet-defaulticon-compatibility";
import "@/plugins/L.tilelayer.wmts";
import * as esri from "esri-leaflet";

L.esri = esri;
import _ from "lodash";
import moment from "moment-timezone";
moment.locale("en-gb");
window.L = L;
import alertify from "alertify.js";
Vue.prototype.$L = L;
Vue.prototype.$_ = _;
Vue.prototype.$alertify = alertify;
Vue.prototype.$moment = moment;


export const eventBus = new Vue();

waitForAuth().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
});
